// import * as echarts from 'echarts/core';
// import { GridComponent, TitleComponent } from 'echarts/components';
// import { BarChart } from 'echarts/charts';
// import { CanvasRenderer } from 'echarts/renderers';

// echarts.use([GridComponent, TitleComponent, BarChart, CanvasRenderer]);
// import echarts from 'echarts';
export default {
  data() {
    return {
      option1: {
        title: {
          text: t('订单正向')+'：',
          textStyle: {	//---主标题内容样式
            fontSize: 14,
            color: '#ed4014',
          },
          // subtext: '',
          subtextStyle: {//---副标题内容样式
            // color: '#bbb'
          },
          padding: [16, 0, 0, 10]//---标题位置,因为图形是是放在一个dom中,因此用padding属性来定位
        },
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0, rotate: 30 },
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            label: {
              show: true,     //开启显示
              position: 'top',    //在上方显示
            },
          }
        ]
      }
    }
  },
  mounted() { },
  methods: {
    async showEchart() {
      const echarts = await import("echarts");
      const option1 = _.cloneDeep(this.option1)
      option1.xAxis.data = this.warningList1.map(i => i.title)
      option1.series[0].data = this.warningList1.map(i => i.count)
      var chartDom = document.getElementById('orderForwardBar');
      if (myChart) {
        myChart.dispose();
      }
      var myChart = echarts.init(chartDom);
      myChart.setOption(option1);

      const option2 = _.cloneDeep(this.option1)
      option2.xAxis.data = this.warningList2.map(i => i.title)
      option2.series[0].data = this.warningList2.map(i => i.count)
      option2.title.text = t('订单逆向')+'：'
      var chartDom2 = document.getElementById('orderReverseBar');
      if (myChart2) {
        myChart2.dispose();
      }
      var myChart2 = echarts.init(chartDom2);
      myChart2.setOption(option2);
    }
  }
}





